import { render, staticRenderFns } from "./AbonadosFromLista.vue?vue&type=template&id=5404c1bf&scoped=true"
import script from "./AbonadosFromLista.vue?vue&type=script&lang=js"
export * from "./AbonadosFromLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404c1bf",
  null
  
)

export default component.exports